
import React from 'react'
import Info from './components/Info'
// import LogoUploader from './components/LogoUploader'
import OfficeAddress from './components/OfficeAddress'
import SocialMedia from './components/SocialMedia'
// import useSWR from 'swr'
import useMerchant from 'hooks/useMerchant'
import useCountries from 'hooks/useCountries'
import Spinner from 'components/Spinner'

export default function BusinessInfo() {
  const { merchant } = useMerchant()
  const { countries } = useCountries()

  // console.log("Merchant data", merchant)

  return (
    <section className="w-full rounded-xl">
      {
        merchant ? (
          <>
            <Info info={merchant} />

            <OfficeAddress info={merchant} countries={countries} />

            <SocialMedia info={merchant} />
          </>
        ) : <Spinner className='bg-white ' height='60vh' />
      }

    </section>
  )
}
